module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "id": "employee"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-collapse', {
    staticStyle: {
      "margin-bottom": "15px"
    },
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-collapse-item', {
    attrs: {
      "title": "操作面板",
      "name": "1"
    }
  }, [_c('div', {
    staticClass: "t-op__container"
  }, [_c('div', {
    staticClass: "t-op__item"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-circle-plus"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("添加")])], 1), _vm._v(" "), _c('div', {
    staticClass: "t-op__item"
  }, [_c('el-input', {
    staticClass: "input-with-select",
    attrs: {
      "placeholder": "请输入员工姓名"
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.loadData
    },
    slot: "append"
  })], 1)], 1)])])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.tableData,
      "width": "100%",
      "height": _vm.tableHeight,
      "stripe": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "width": "70",
      "type": "index",
      "label": "序号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "label": "员工姓名",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "登陆名",
      "prop": "loginName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "label": "帐号状态",
      "prop": "status",
      "formatter": _vm.fmtStatus
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "label": "所属角色",
      "prop": "isAdmin",
      "formatter": _vm.fmtIsAdmin
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "手机号",
      "prop": "mobile"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "级别",
      "prop": "levelId",
      "formatter": _vm.fmtLevel
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "label": "员工类别",
      "prop": "type",
      "formatter": _vm.fmtType
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "120",
      "label": "微信昵称",
      "prop": "nickName"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "微信头像"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.avatar) ? _c('img', {
          staticStyle: {
            "width": "30px",
            "height": "30px",
            "border-radius": "30px"
          },
          attrs: {
            "src": scope.row.avatar
          }
        }) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "label": "操作",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("修改\n                        ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "padding": "10px 0px"
    },
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "hide-on-single-page": _vm.value,
      "page-size": _vm.pageSize,
      "total": _vm.total,
      "current-page": _vm.pageIndex
    },
    on: {
      "current-change": _vm.onCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editItem.title,
      "width": _vm.editItem.width,
      "visible": _vm.editItem.visible
    },
    on: {
      "update:visible": function($event) {
        return _vm.$set(_vm.editItem, "visible", $event)
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.editItem.data
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: (_vm.editItem.data.name),
      callback: function($$v) {
        _vm.$set(_vm.editItem.data, "name", $$v)
      },
      expression: "editItem.data.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "登陆帐号",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: (_vm.editItem.data.loginName),
      callback: function($$v) {
        _vm.$set(_vm.editItem.data, "loginName", $$v)
      },
      expression: "editItem.data.loginName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "show-password": "",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.editItem.data.password),
      callback: function($$v) {
        _vm.$set(_vm.editItem.data, "password", $$v)
      },
      expression: "editItem.data.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "帐号状态",
      "label-width": "150px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.editItem.data.status),
      callback: function($$v) {
        _vm.$set(_vm.editItem.data, "status", $$v)
      },
      expression: "editItem.data.status"
    }
  }, _vm._l((_vm.editItem.statusList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属角色",
      "label-width": "150px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.editItem.data.isAdmin),
      callback: function($$v) {
        _vm.$set(_vm.editItem.data, "isAdmin", $$v)
      },
      expression: "editItem.data.isAdmin"
    }
  }, _vm._l((_vm.editItem.roleList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "微信openId(意臣)",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: (_vm.editItem.data.openId),
      callback: function($$v) {
        _vm.$set(_vm.editItem.data, "openId", $$v)
      },
      expression: "editItem.data.openId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "头像地址",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: (_vm.editItem.data.avatar),
      callback: function($$v) {
        _vm.$set(_vm.editItem.data, "avatar", $$v)
      },
      expression: "editItem.data.avatar"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "label-width": "150px"
    }
  }, [_c('el-input', {
    attrs: {
      "autocomplete": "off"
    },
    model: {
      value: (_vm.editItem.data.mobile),
      callback: function($$v) {
        _vm.$set(_vm.editItem.data, "mobile", $$v)
      },
      expression: "editItem.data.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "级别",
      "label-width": "150px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.editItem.data.levelId),
      callback: function($$v) {
        _vm.$set(_vm.editItem.data, "levelId", $$v)
      },
      expression: "editItem.data.levelId"
    }
  }, _vm._l((_vm.editItem.levelList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.level,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "员工类别",
      "label-width": "150px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.editItem.data.type),
      callback: function($$v) {
        _vm.$set(_vm.editItem.data, "type", $$v)
      },
      expression: "editItem.data.type"
    }
  }, _vm._l((_vm.editItem.typeList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.editItem.visible = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc41dd78"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/admin/employee/employeeManage.vue
// module id = 624
// module chunks = 1